import { Box } from '@mui/material';

export default function LogoMark({ size = 32 }) {
  return <Box component="img" src="/mux-mark.svg" alt="" aria-hidden="true" sx={{ width: size, height: size, flexShrink: 0 }} />;
}
